import React from 'react';
import { Environment } from 'src/Environment';
import { VodapayLogoV2, VodapayLogoWithTextV2 } from 'src/assets/images';
import TealiumEvents from 'src/helpers/tealium-events';
import MiniAppEvents from 'src/helpers/miniapp-events';
import { useHistory } from 'react-router';
import { CustomerTypes } from '../../types/customer-types';
import { publicSiteUrl } from 'src/common';
import './onboarding-form-background.scss';

export function OnboardingFormBackground({
  isAgent,
  customerType,
  setCustomerType,
  children,
  includeMiniAppBack,
}) {
  const history = useHistory();
  const inMiniProgram = MiniAppEvents.isInMiniApp();

  //todo get the current env link and then go to onboarding/start?customerType=normal and check that it set the state to normal correctly
  const useHashRouting =
    Environment.current?.disabledFeatures?.merchantRoutingForBcaAndSelfServiceAndUseBrowserRouter;
  const merchantUrl = `${Environment.current?.uiHost}/${
    useHashRouting ? 'merchant/index.html#/' : ''
  }onboarding/start`;

  const backLink = () => (
    <div className="has-text-left back-link">
      {inMiniProgram ? (
        <>
          {includeMiniAppBack && (
            <span
              className="miniapp-back"
              onClick={() => history.goBack()}
              automationid="Onboarding_Lets_Get_Started_Span_Link_Back_To_Vodacom"
            >
              Back to previous page
              <span className="icon-menu-chevron-right has-padding-left-6 is-size-7" />
            </span>
          )}
        </>
      ) : (
        <a
          onClick={() => {
            TealiumEvents.letsGetStartedClickBackToVodacom(publicSiteUrl, customerType);
            window.location.href = publicSiteUrl;
          }}
          automationid="Onboarding_Lets_Get_Started_Span_Link_Back_To_Vodacom"
        >
          Back to Vodacombusiness.co.za
          <span className="icon-menu-chevron-right has-padding-left-6 is-size-7" />
        </a>
      )}
    </div>
  );

  const switchToMerchantLink = () => (
    <div className="has-text-left back-link">
      <a
        href={merchantUrl}
        onClick={() => {
          TealiumEvents.notAnAgentEvent(publicSiteUrl, customerType);
          if (setCustomerType) {
            setCustomerType(CustomerTypes.normal);
          }
        }}
        automationid="Onboarding_Agent_Login_Span_Link_Back_To_Vodacom"
      >
        Not an agent? Sign up as a Merchant
        <span className="icon-menu-chevron-right has-padding-left-6 is-size-7" />
      </a>
    </div>
  );

  const staticContent = () => {
    return (
      <div className="columns full-height is-vcentered">
        <div className="column is-8 is-offset-2">
          <img src={VodapayLogoWithTextV2} className="logo" alt="Vodapay logo" />
          <p className="titleText">
            {isAgent
              ? 'Help Merchants meet their business needs with VodaPay Devices'
              : 'Sign up for a VodaPay device and make accepting payments easier'}
          </p>
          <p className="subtext has-padding-top-4">
            {isAgent ? 'One portal, one view, one solution.' : 'Tap, dip, swipe, QR scan.'}
          </p>
          {isAgent ? switchToMerchantLink() : backLink()}
        </div>
      </div>
    );
  };

  return (
    <div className="OnboardingFormBackground">
      <section className="background-image">
        <div className="columns is-mobile is-gapless">
          <div className={`column is-5 full-height is-hidden-mobile`}>{staticContent()}</div>
          <div className="column full-height is-vcentered is-centered">
            <div className="form-wrapper">
              <div className="form">
                <img className="mobileLogo" src={VodapayLogoV2} alt="Vodacom logo" />
                {children}
                <div className="mobile-only">{isAgent ? switchToMerchantLink() : backLink()}</div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
